import urls from './urls';
import axios from 'axios';

export default class whatAreYourInterestsApi {
  static loadGeneralData() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_GENERAL_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadSexualDataSignle() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_SEXUAL_SINGLE_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadSexualDataCouple() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_SEXUAL_COUPLE_DATA;
    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }

  static loadFetishData() {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_FETISH_DATA;

    // return this.restClient.execute(url, ApiMethod.GET, null, true).then(res => {
    //   return res;
    // });
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: true } }).then(res => res);
  }
}
